export default __webpack_public_path__ + "static/media/interstellarCard.529f372d.jpg";